import React from 'react';

import './styles.scss';

interface BetButtonProps {
  link: string;
}

function BetButton({link}: BetButtonProps): JSX.Element {
  return (
    <a className="BetButton" href={link} target="_blank" rel="noreferrer">
      LIVE BET
    </a>
  );
}

export default BetButton;
